import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { GzTextWebComponent } from '../../../../../ui/gzText';
import { GzButtonWebComponent } from '../../../../../ui/gzButton';
import { InProductTrialsOverlayWindowType } from '../../types/InProductTrialsOverlayWindowType';
import { getContentConfigForInProductTrialsOverlayWindowType } from './configs/in-product-trials-overlay-window-content-config';
import {
  InProductTrialsOverlayWindowButton,
  InProductTrialsOverlayWindowContentConfig,
} from '../types/InProductTrialsOverlayWindowContentConfig';
import { toggleVisibility } from '../../../../../utils/htmlElement.utils';

export class InProductTrialsOverlayContentView extends BaseWebComponentView {
  public overlayWindowConfig: InProductTrialsOverlayWindowContentConfig;
  public overlayWindowType: InProductTrialsOverlayWindowType;

  public dom: {
    $wrapper: HTMLElement;

    $windowImage: HTMLImageElement;
    $windowTitle: GzTitleWebComponent;
    $windowText: GzTextWebComponent;

    $button1: GzButtonWebComponent;
    $button2: GzButtonWebComponent;
    $button3: GzButtonWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $windowImage: this.shadow.querySelector('#in-product-trials-overlay-window-image'),
      $windowTitle: this.shadow.querySelector('#in-product-trials-overlay-window-title'),
      $windowText: this.shadow.querySelector('#in-product-trials-overlay-window-text'),

      $button1: this.shadow.querySelector('#in-product-trials-overlay-window-button1'),
      $button2: this.shadow.querySelector('#in-product-trials-overlay-window-button2'),
      $button3: this.shadow.querySelector('#in-product-trials-overlay-window-button3'),
    };
  }

  buildSuccessView({
    inProductTrialsOverlayWindowType,
  }: {
    inProductTrialsOverlayWindowType: InProductTrialsOverlayWindowType;
  }) {
    this.overlayWindowType = inProductTrialsOverlayWindowType;
    this.overlayWindowConfig = getContentConfigForInProductTrialsOverlayWindowType(this.overlayWindowType);

    this.dom.$windowImage.src = this.overlayWindowConfig.imageSrc;
    this.dom.$windowTitle.innerText = this.overlayWindowConfig.title;
    this.dom.$windowText.innerHTML = this.overlayWindowConfig.text;

    // set buttons config
    this.setButtonElementConfig(this.dom.$button1, this.overlayWindowConfig.buttons.button1);
    this.setButtonElementConfig(this.dom.$button2, this.overlayWindowConfig.buttons.button2);

    if (this.overlayWindowConfig.buttons.button3) {
      toggleVisibility(this.dom.$button3, true);
      this.setDisplayStyleToButtons('block');
      this.setButtonElementConfig(this.dom.$button3, this.overlayWindowConfig.buttons.button3);
    } else {
      toggleVisibility(this.dom.$button3, false);
      this.setDisplayStyleToButtons('inline');
    }
  }

  private setButtonElementConfig(button: GzButtonWebComponent, buttonConfig: InProductTrialsOverlayWindowButton) {
    button.innerText = buttonConfig.innerText;
    button.theme = buttonConfig.theme;
    button.color = buttonConfig.color;
    button.type = buttonConfig.type;
  }

  private setDisplayStyleToButtons(display: string) {
    this.dom.$button1.style.display = display;
    this.dom.$button2.style.display = display;
    this.dom.$button3.style.display = display;
  }
}
